class ApiCmsFixLayout {
    static init() {
        ApiCmsFixLayout.#sidebar();
        ApiCmsFixLayout.#fixLayout();
        ApiCmsFixLayout.#dropDownBootstrap();
    };

    // noinspection JSUnusedLocalSymbols
    static #detectMobile() {
        return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    };

    static #scrollbar(className, color, cursorWidth) {
        $(className).niceScroll({
            cursorcolor: color,
            cursorborder: 0,
            cursorborderradius: 0,
            cursorwidth: cursorWidth,
            bouncescroll: true,
            mousescrollstep: 100
        });
    };

    static #sidebar() {
        $('.close-right-menu').on('click', function(e) {
            e.preventDefault();
            $(this).parents('.right-menu').removeClass('toggled');
        });
        const $body = $('body');
        const $header = $('#header');
        const $rightMenu = $('#right-menu');
        const $sidebar = $('#sidebar');
        //Sidebar

        $body.on('click', '#menu-trigger, .right-menu-trigger', function(e) {
            const $elem2 = '#menu-trigger';
            const $elem = '#sidebar';
            e.preventDefault();
            const x = $(this).data('trigger');
            $('.right-menu').removeClass('toggled');
            $(x).toggleClass('toggled');
            $(this).toggleClass('open');

            // if ($(this).attr('id') !== 'right-menu-trigger') {
            //     $body.toggleClass('modal-open');

            // }
            //Close opened sub-menus
            $('.sub-menu.toggled').not('.active').each(function() {
                $(this).removeClass('toggled');
                $(this).find('ul').hide();
            });

            $('.profile-menu .main-menu').hide();

            if (x === '#sidebar') {
                $('#right-menu-trigger').removeClass('open');

                if (!$rightMenu.hasClass('toggled')) {
                    $header.toggleClass('sidebar-toggled');
                } else {
                    $rightMenu.removeClass('toggled');
                }
            }

            //When clicking outside
            if ($header.hasClass('sidebar-toggled')) {
                $(document).on('click', function(e) {
                    if (($(e.target).closest($elem).length === 0) && ($(e.target).closest($elem2).length === 0)) {
                        setTimeout(function() {
                            $body.removeClass('modal-open');
                            $($elem).removeClass('toggled');
                            $header.removeClass('sidebar-toggled');
                            $($elem2).removeClass('open');
                        });
                    }
                });
            }
        });

        //Submenu
        $body.on('click', '.sub-menu > a', function(e) {
            e.preventDefault();
            $(this).next().slideToggle(200);
            $(this).parent().toggleClass('toggled');
        });

        //Get saved layout type from LocalStorage
        const layoutStatus = localStorage.getItem('ma-layout-status');
        if (layoutStatus === 1) {
            $body.addClass('sw-toggled');
            $('#tw-switch').prop('checked', true);
        }

        $body.on('change', '#toggle-width input:checkbox', function() {
            if ($(this).is(':checked')) {
                setTimeout(function() {
                    $body.addClass('toggled sw-toggled');
                    localStorage.setItem('ma-layout-status', 1);
                    animateMainmenu(0, 100); // TODO: Sprawdzić tę funkcję
                }, 250);
            } else {
                setTimeout(function() {
                    $body.removeClass('toggled sw-toggled');
                    localStorage.setItem('ma-layout-status', 0);
                    $('.main-menu > li').removeClass('animated');
                }, 250);
            }
        });

        $sidebar.niceScroll({
            cursorcolor: '#FF6600',
            cursorborder: 0,
            cursorborderradius: 0,
            cursorwidth: 3,
            bouncescroll: true,
            mousescrollstep: 100,
            autohidemode : false,
            horizrailenabled : false
        });

        $sidebar.on('transitionend webkitTransitionEnd oTransitionEnd otransitionend MSTransitionEnd', function() {
            $('#sidebar').getNiceScroll().resize();
        })
    };

    static #dropDownBootstrap() {
        const $dropdown = $('.dropdown');
        let $animationDuration = '';
        let $animationIn, $animationOut;
        //Dropdown Menu
        if ($dropdown[0]) {
            //Propagate
            $('body').on('click', '.dropdown.open .dropdown-menu', function(e) {
                e.stopPropagation();
            });

            // noinspection JSUnusedLocalSymbols
            $dropdown.on('shown.bs.dropdown', function(e) {
                if ($(this).attr('data-animation')) {
                    const $animation = $(this).data('animation');
                    const $animArray = $animation.split(',');
                    $animationIn = 'animated ' + $animArray[0];
                    $animationOut = 'animated ' + $animArray[1];

                    if (!$animArray[2]) {
                        $animationDuration = 500; //if duration is not defined, default is set to 500ms
                    } else {
                        $animationDuration = $animArray[2];
                    }

                    $(this).find('.dropdown-menu').removeClass($animationOut);
                    $(this).find('.dropdown-menu').addClass($animationIn);
                }
            });

            $dropdown.on('hide.bs.dropdown', function(e) {
                if ($(this).attr('data-animation')) {
                    e.preventDefault();
                    const $this = $(this);
                    const $dropdownMenu = $this.find('.dropdown-menu');

                    $dropdownMenu.addClass($animationOut);
                    setTimeout(function() {
                        $this.removeClass('open');

                    }, $animationDuration);
                }
            });
        }
    };

    static #fixLayout() {
        const $body = $('body');
        const $header = $('#header');
        //Top Search
        $body.on('click', '#top-search > a', function(e) {
            e.preventDefault();

            $header.addClass('search-toggled');
        });
        $body.on('click', '#top-search-close', function(e) {
            e.preventDefault();

            $header.removeClass('search-toggled');
        });

        //Clear Notification
        $body.on('click', '[data-clear="notification"]', function(e) {
            e.preventDefault();

            const x = $(this).closest('.listview');
            const y = x.find('.lv-item');
            const z = y.size();

            $(this).parent().fadeOut();

            x.find('.list-group').prepend('<i class="grid-loading hide-it"></i>');
            x.find('.grid-loading').fadeIn(1500);


            let w = 0;
            y.each(function() {
                const z = $(this);
                setTimeout(function() {
                    z.addClass('animated fadeOutRightBig').delay(1000).queue(function() {
                        z.remove();
                    });
                }, w += 150);
            });

            //Popup empty message
            setTimeout(function() {
                $('#notifications').addClass('empty');
            }, (z * 150) + 200);
        });

        //Scrollbar for HTML(not mobile) but not for login page
        if (!$('html').hasClass('ismobile')) {
            if (!$('.login-content')[0]) {
                //ApiCmsFixLayout.#scrollbar('html', 'rgba(0,0,0,0.3)', '5px');
            }

            //Scroll bar for Chosen
            if ($('.chosen-results')[0]) {
                ApiCmsFixLayout.#scrollbar('.chosen-results', 'rgba(0,0,0,0.5)', '5px');
            }

            //Scroll bar for tabs
            if ($('.tab-nav')[0]) {
                ApiCmsFixLayout.#scrollbar('.tab-nav', 'rgba(0,0,0,0)', '1px');
            }

            //Scroll bar for dropdowm-menu
            if ($('.dropdown-menu .c-overflow')[0]) {
                ApiCmsFixLayout.#scrollbar('.dropdown-menu .c-overflow', 'rgba(0,0,0,0.5)', '0px');
            }

            //Scrollbar for rest
            if ($('.c-overflow')[0]) {
                ApiCmsFixLayout.#scrollbar('.c-overflow', 'rgba(0,0,0,0.5)', '5px');
            }
        }

        //Profile Menu
        $body.on('click', '.profile-menu > a', function(e) {
            e.preventDefault();
            $(this).parent().toggleClass('toggled');
            $(this).next().slideToggle(200);
        });

        //Audio and Video
        if ($('audio, video')[0]) {
            // noinspection JSUnresolvedFunction
            $('video,audio').mediaelementplayer();
        }

        //Waves Animation
        if ($.isFunction(Waves)) {
            Waves.attach('a.btn, button.btn', ['waves-button', 'waves-float']);
            Waves.init();
        }

        const $lightbox = $('.lightbox');
        //Lightbox
        if ($lightbox[0]) {
            $lightbox.lightGallery({
                enableTouch: true
            });
        }

        //Link prevent
        $body.on('click', '.a-prevent', function(e) {
            e.preventDefault();
        });

        const $collapse = $('.collapse');
        //Collapse Fix
        if ($collapse[0]) {
            //Add active class for opened items
            // noinspection JSUnusedLocalSymbols
            $collapse.on('show.bs.collapse', function(e) {
                $(this).closest('.panel').find('.panel-heading').addClass('active');
            });

            // noinspection JSUnusedLocalSymbols
            $collapse.on('hide.bs.collapse', function(e) {
                $(this).closest('.panel').find('.panel-heading').removeClass('active');
            });

            //Add active class for pre opened items
            $('.collapse.in').each(function() {
                $(this).closest('.panel').find('.panel-heading').addClass('active');
            });
        }

        const $tooltips = $('[data-toggle="tooltip"]');
        //Tooltips
        if ($tooltips[0]) {
            $tooltips.tooltip({
                html: true
            });
        }

        const $popovers = $('[data-toggle="popover"]');
        //Popover
        if ($popovers[0]) {
            $popovers.popover({
                html: true
            });
        }

        const $onSelect = $('.on-select');
        //Actions
        if ($onSelect[0]) {
            const checkboxes = '.lv-avatar-content input:checkbox';
            const actions = $onSelect.closest('.lv-actions');

            $body.on('click', checkboxes, function() {
                if ($(checkboxes + ':checked')[0]) {
                    actions.addClass('toggled');
                } else {
                    actions.removeClass('toggled');
                }
            });
        }

        if ($('#ms-menu-trigger')[0]) {
            $body.on('click', '#ms-menu-trigger', function(e) {
                e.preventDefault();
                $(this).toggleClass('open');
                $('.ms-menu').toggleClass('toggled');
            });
        }

        const $clearLocalStorage = $('[data-action="clear-localstorage"]');
        //Clear Local Storage
        if ($clearLocalStorage[0]) {
            $clearLocalStorage.on('click', function(e) {
                e.preventDefault();

                swal({
                    title: "Are you sure?",
                    text: "All your saved localStorage values will be removed",
                    type: "warning",
                    showCancelButton: true,
                    confirmButtonColor: "#DD6B55",
                    confirmButtonText: "Yes, delete it!",
                    closeOnConfirm: false
                }, function() {
                    localStorage.clear();
                    swal("Done!", "localStorage is cleared", "success");
                });
            });
        }

        //Profile Edit Toggle
        if ($('[data-pmb-action]')[0]) {
            $body.on('click', '[data-pmb-action]', function(e) {
                e.preventDefault();
                const d = $(this).data('pmb-action');

                if (d === "edit") {
                    $(this).closest('.pmb-block').toggleClass('toggled');
                }

                if (d === "reset") {
                    $(this).closest('.pmb-block').removeClass('toggled');
                }
            });
        }
    }
}
